<template>
  <div class="progressBox" :style="'background:'+bgColor">
      <div :style="'background:'+color+';width:'+percent+'%'">
          <span :style="Number(percent)<50?'right:-40px':'right:0px'">{{percent}}%</span>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        percent:{
            type:String,
            default() {
                return '0'
            }
        },
        color:{
            type:String,
            default() {
                return '#1989FA'
            }
        },
        bgColor:{
            type:String,
            default() {
                return '#CBFFFE'
            }
        }
    }
}
</script>

<style lang='scss' scoped>
    .progressBox {
        width: 100%;
        height: 8px;
        border-radius: 3px;
        margin: 30px 0 20px 0;
        >div {
            height: 8px;
            border-radius: 3px;
            position: relative;
            >span {
                color: #777;
                position: absolute;
                top:-15px;
                // right: -30px;
                font-size: 13px;
            }
        }
    }
</style>